import { Component } from '@angular/core';

export enum ViewType {
  DESKTOP,
  MOBILE,
}

@Component({
  selector: 'mprd-cloud-download',
  templateUrl: './cloud-download.component.html',
  styleUrls: ['./cloud-download.component.css'],
})
export class CloudDownloadComponent {
  public selectedMobileView: ViewType = ViewType.MOBILE;
  public selectedDesktopView: ViewType = ViewType.DESKTOP;
  public ViewType = ViewType;

  constructor() {}

  public toggleMobileView() {
    this.selectedMobileView =
      this.selectedMobileView === ViewType.DESKTOP
        ? ViewType.MOBILE
        : ViewType.DESKTOP;
  }

  public toggleDesktopView() {
    this.selectedDesktopView =
      this.selectedDesktopView === ViewType.DESKTOP
        ? ViewType.MOBILE
        : ViewType.DESKTOP;
  }
}
